<template>
  <div>
    <div class="card" v-if="clients.length > 0 || Number($store.state.role) === 2">
      <div class="row menubar">
        <input
          type="text"
          v-model="search"
          ref="search"
          placeholder="Zoeken"
          @keyup="updateSearch"
          class="searchbar"
        />
        <!-- type sorting -->
        <div v-if="$parent.role !== '2'" class="dropdown nowrap" style="float:right;">
          <button class="dropdown-button" @click="dropdownlist = !dropdownlist">
            <awesomeIcon icon="sort" /> {{ find(orders, {value: order }).label}}
          </button>
          <div
            class="dropdown-bg"
            v-if="dropdownlist"
            @click="dropdownlist = !dropdownlist"
          ></div>
          <ul class="dropdown-list" v-if="dropdownlist">
            <li
              v-for="(group) in orders"
              :key="group.value"
              @click="
                dropdownlist = !dropdownlist;
                chooseOrder(group.value);
              "
            >
              {{ group.label }}
            </li>
            <li class="dropdown-cancel" @click="dropdownlist = !dropdownlist">Annuleren</li>
          </ul>
        </div>
      </div>
      <table width="100%">
        <thead class="table-legend">
          <tr v-if="$parent.role === '2'">
            <th>Rek. nummer</th>
            <th>Gebruiker</th>
            <th>Doeltype / Doelmeter</th>
            <th></th>
          </tr>
          <tr v-else>
            <th>Gebruiker</th>
            <th>Rekening/intake</th>
            <th></th>
          </tr>
        </thead>
        <tr v-for="(client, index) in slice(
            filter(sortBy(clients, order), searchFilter),
            currentPage * resultsPerPage, (
              currentPage + 1
            ) * resultsPerPage
          )"
          :key='`client${index}type${client.type}`'
        >
        <template v-if="$parent.role === '2'">
          <td
            class="grey concat"
            :title="`Rek. nummer: #${client.port.id}`"
          >
            #{{client.port.id}}
          </td>
          <td>
            {{client.name ? client.name : '-'}}<br />
            <span class="grey concat" :title="client.email">{{ client.email }}</span>
          </td>
          <td>
            Doeltype:
            <span class="grey concat">
              {{
                typeToText(client.port.type)
              }}
            </span><br />
            Doel datum:
            <span class="grey concat">
              {{(new Date(client.port.target_date)).toLocaleDateString()}}
            </span>
            <template v-if="client.type === 'port'
              && (client.port.type === 3
                || client.port.type === 7
                || client.port.type === 9
                || client.port.type === 11)
              && Math.ceil(daysTillGoal(client.port)) < 180
              && Math.ceil(daysTillGoal(client.port)) > 0"
            >
              <awesomeIcon
                icon="exclamation-circle" class="grey"
                :title="`Persoon bereikt doel binnen 6 maanden.`"
              />
            </template>
            <template v-else-if="client.type === 'port'
              && (client.port.type === 3
                || client.port.type === 7
                || client.port.type === 9
                || client.port.type === 11)
              && Math.ceil(daysTillGoal(client.port)) < 1"
            >
              <awesomeIcon
                icon="exclamation-circle" class="grey"
                :title="`Persoon heeft de doel datum bereikt.`"
              />
            </template>
          </td>
          <td style="float:right;">
            <button
              v-if="client.status !== 'Nog niet geaccepteerd'"
              @click="becomeUserBasedOnType(client)"
              class="secondary hide-mobile"
              style="padding-top: 10px;"
            >
              <awesomeIcon icon="search"/> Bekijk
            </button>
          </td>
        </template>
        <template v-else>
          <td>
            {{client.name ? client.name : '-'}}
            <br />
              <span class="grey concat" :title="client.email">{{ client.email }}</span>
          </td>
          <td v-if="client.type == 'without'">
            {{
              client.status === 'Nog niet geaccepteerd'
              ? 'Uitnodiging nog niet geaccepteerd'
              : 'Nog geen vragenlijst gestart'
            }}
          </td>
          <td v-else-if="client.type == 'port'">
            <span class="grey concat" :title="client.port.id">
              #{{ client.port.id }} [<i>Rek. nummer</i>]
            </span><br />
            Doeltype:
            <span class="grey concat">
              {{
                typeToText(client.port.type)
              }}
            </span><br />
            Doel datum:
            <span class="grey concat">
              {{(new Date(client.port.target_date)).toLocaleDateString()}}
            </span>
            <template v-if="client.type === 'port'
              && (client.port.type === 3
                || client.port.type === 7
                || client.port.type === 9
                || client.port.type === 11)
              && Math.ceil(daysTillGoal(client.port)) < 180
              && Math.ceil(daysTillGoal(client.port)) > 0"
            >
              <awesomeIcon
                icon="exclamation-circle" class="grey"
                :title="`Persoon bereikt doel binnen 6 maanden.`"
              />
            </template>
            <template v-else-if="client.type === 'port'
              && (client.port.type === 3
                || client.port.type === 7
                || client.port.type === 9
                || client.port.type === 11)
              && Math.ceil(daysTillGoal(client.port)) < 1"
            >
              <awesomeIcon
                icon="exclamation-circle" class="grey"
                :title="`Persoon heeft de doel datum bereikt.`"
              />
            </template>
          </td>
          <td v-else-if="client.type == 'intake'">
            <span class="grey concat" :title="client.intake.id">
              #{{ client.intake.id }} [<i>Intake nummer</i>]
            </span><br />
            Status:
            <span class="grey concat" :title="client.intake.status">
              {{
              client.intake.status
              ? client.intake.status
              : '-'
              }}
            </span><br />
            Doeltype:
            <span class="grey concat">
              {{
                client.intake.intakeData
                && client.intake.intakeData.goalData
                ? typeToGoal(client.intake.intakeData.goalData)
                : '-'
              }}
            </span><br />
            Doelmeter:
            <span class="grey concat">
              {{ client.intake.intakeData
                && client.intake.intakeData.goalData
                && client.intake.intakeData.goalData.score
              ? `${formatPrice(client.intake.intakeData.goalData.score, true)}%`
              : '-'}}
            </span><br />
            Voortgang:
            <span class="grey concat">
              {{
              client.intake.intakeData
              && client.intake.intakeData.progress
              ? `${formatPrice(client.intake.intakeData.progress, true)}%`
              : '-'}}
            </span>
          </td>
          <td style="float:right;">
            <button
              v-if="client.status !== 'Nog niet geaccepteerd'"
              @click="becomeUserBasedOnType(client)"
              class="secondary hide-mobile"
              style="padding-top: 10px;"
            >
              <awesomeIcon icon="search"/> Bekijk
            </button>
          </td>
          <td style="float:right;">
            <button
              @click="$parent.removeMandate(client.client)"
              class="secondary hide-mobile"
              style="padding-top: 10px;"
            >
              <awesomeIcon icon="times"/>
              {{
                (client.status === 'Nog niet geaccepteerd')
                ? 'Uitnodiging intrekken'
                : 'Ontkoppelen'
              }}
            </button>
          </td>
        </template>
        </tr>
      </table>
      <pagerElement
        v-model="currentPage"
        :records="filter(clients, searchFilter).length"
        :resultsPerPage="resultsPerPage"
      />
    </div>
  </div>
</template>

<script>
import {
  find, filter, slice, sortBy, cloneDeep,
} from 'lodash-es';

export default {
  name: 'OnboardingAll',
  data() {
    return {
      search: '',
      order: 'port.id',
      orders: [
        { label: 'Naam', value: 'name' },
        { label: 'E-mail', value: 'email' },
        { label: 'Portefeuille', value: 'port.id' },
        { label: 'Intake', value: 'intake.id' },
        { label: 'Intake Voortgang', value: 'intake.progressRev' },
      ],
      dropdownlist: false,
      currentPage: 0,
      resultsPerPage: 10,
    };
  },
  computed: {
    clients() {
      const temp = [];
      for (let i = 0; i < this.$parent.allClients.length; i += 1) {
        if (this.$parent.role !== '2') {
          if (
            !this.$parent.allClients[i].intakes.length && !this.$parent.allClients[i].ports.length
          ) {
            const tempObj = cloneDeep(this.$parent.allClients[i]);
            tempObj.intake = { progressRev: 101 };
            tempObj.type = 'without';
            temp.push(tempObj);
          }
          for (let j = 0; j < this.$parent.allClients[i].intakes.length; j += 1) {
            const tempObj = cloneDeep(this.$parent.allClients[i]);
            tempObj.type = 'intake';
            tempObj.intake = tempObj.intakes[j];
            tempObj.intake.progressRev = 100 - Number(tempObj.intake.intakeData.progress);
            delete tempObj.intakes;
            temp.push(tempObj);
          }
        }
        for (let j = 0; j < this.$parent.allClients[i].ports.length; j += 1) {
          const tempObj = cloneDeep(this.$parent.allClients[i]);
          tempObj.type = 'port';
          tempObj.intake = { progressRev: 101 };
          tempObj.port = tempObj.ports[j];
          delete tempObj.ports;
          temp.push(tempObj);
        }
      }
      return temp;
    },
  },
  methods: {
    find,
    slice,
    filter,
    sortBy,
    typeToText(type) {
      if (type === 1) {
        return 'Zorgpotje';
      }
      if (type === 2) {
        return 'Hypotheek';
      }
      if (type === 3) {
        if (this.$parent.role === '2') {
          return 'Beleggingsrekening voor kinderen';
        }
        return 'Studie kind';
      }
      if (type === 4) {
        return 'Grote Aankoop';
      }
      if (type === 5) {
        return 'Pensioen';
      }
      if (type === 6) {
        return 'Levensonderhoud';
      }
      if (type === 7) {
        if (this.$parent.role === '2') {
          return 'Lijfrente opbouwen/uitstellen (box 1)';
        }
        return 'Pensioen (Box 1)';
      }
      if (type === 8) {
        return 'Leefrente (Box 1)';
      }
      if (type === 9) {
        if (this.$parent.role === '2') {
          return 'gouden handdruk uitstellen';
        }
        return 'Gouden handdruk (opbouwend)';
      }
      if (type === 10) {
        if (this.$parent.role === '2') {
          return 'gouden handdruk uitkeren';
        }
        return 'Gouden handdruk (uitkerend)';
      }
      if (type === 11) {
        if (this.$parent.role === '2') {
          return 'Netto lijfrente';
        }
        return 'Netto lijfrente (opbouwend)';
      }
      if (type === 12) {
        if (this.$parent.role === '2') {
          return 'Lijfrente uitkeren (box 1)';
        }
        return 'Netto lijfrente(uitkerend)';
      }
      if (this.$parent.role === '2') {
        return 'Privé/zakelijke beleggingsrekening';
      }
      return 'Vermogensopbouw';
    },
    daysTillGoal(port) {
      return (
        (new Date(port.target_date)).getTime()
        - (new Date()).getTime()
      ) / 1000 / 24 / 60 / 60;
    },
    becomeUserBasedOnType(client) {
      if (client.type === 'intake') {
        this.$parent.becomeUser(client.client, client.intake.id);
      } else {
        this.$parent.becomeUser(client.client);
      }
    },
    typeToGoal(data) {
      if (data.type === 'studiekinderen') {
        return 'studie kinderen';
      }
      if (data.type === 'groteaankoop') {
        return 'grote aankoop';
      }
      if (data.type === 'gouden-handdruk-opbouwend') {
        return 'gouden handdruk (opbouwend)';
      }
      if (data.type === 'gouden-handdruk-uitkerend') {
        return 'gouden handdruk (uitkerend)';
      }
      if (data.type === 'netto-lijfrente-uitkerend') {
        return 'Netto lijfrente (uitkerend)';
      }
      if (data.type === 'netto-lijfrente-opbouwend') {
        return 'Netto lijfrente (opbouwend)';
      }
      if (data.type === 'pensioen' && data.box === '1') {
        return 'pensioen (box 1)';
      }
      if (data.type === 'levensonderhoud'
        && data.box === '1') {
        return 'leefrente (box 1)';
      }
      return data.type;
    },
    chooseOrder(group) {
      this.dropdownlist = false;
      this.order = group;
    },
    updateSearch() {
      this.currentPage = 0;
      this.search = this.$refs.search.value.toLowerCase();
    },
    searchFilter(obj) {
      const trimmedSearch = this.search.trim();
      if (obj.type === 'without') {
        // User has no intakes and no ports
        if (obj.name.toLowerCase().indexOf(trimmedSearch) > -1) {
          return true;
        }
        if (obj.email.toLowerCase().indexOf(trimmedSearch) > -1) {
          return true;
        }
      } else if (obj.type === 'concept') {
        // User has concept intake
        if (String(obj.id).indexOf(trimmedSearch) > -1) {
          return true;
        }
        if (this.$parent.typeToATPGoal(
          obj,
        ).toLowerCase().indexOf(trimmedSearch) > -1) {
          return true;
        }
        if (this.formatPrice(
          obj.score,
          true,
        ).indexOf(trimmedSearch) > -1) {
          return true;
        }
      } else if (obj.type === 'port') {
        // User has no intake, but has ports
        if (obj.name.toLowerCase().indexOf(trimmedSearch) > -1) {
          return true;
        }
        if (obj.email.toLowerCase().indexOf(trimmedSearch) > -1) {
          return true;
        }
        if (String(obj.port.id).indexOf(trimmedSearch) > -1) {
          return true;
        }
        if ((new Date(obj.port.target_date)
        ).toLocaleDateString().toLowerCase().indexOf(trimmedSearch) > -1) {
          return true;
        }
      } else if (obj.type === 'intake') {
        // User has intakes, but no ports
        if (obj.name.toLowerCase().indexOf(trimmedSearch) > -1) {
          return true;
        }
        if (obj.email.toLowerCase().indexOf(trimmedSearch) > -1) {
          return true;
        }
        if (String(obj.intake.id).indexOf(trimmedSearch) > -1) {
          return true;
        }
        if (obj.intake.status.toLowerCase().indexOf(trimmedSearch) > -1) {
          return true;
        }
        if (this.typeToGoal(
          obj.intake.intakeData.goalData,
        ).toLowerCase().indexOf(trimmedSearch) > -1) {
          return true;
        }
        if (this.formatPrice(
          obj.intake.intakeData.goalData.score,
          true,
        ).indexOf(trimmedSearch) > -1) {
          return true;
        }
        if (this.formatPrice(
          obj.intake.intakeData.progress,
          true,
        ).indexOf(trimmedSearch) > -1) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
